import { type z } from "zod"
import { ElectricityMeterKind, isPrmCommunicating } from "@/features/meter-points"
import { type ElectricityEligibilityResultSchema } from "@/features/meter-points/schemas/checkMeterPointsEligibilitySchema"

export function parseElectricityMeterPointEligibility(
    meterPointEligibility: z.infer<typeof ElectricityEligibilityResultSchema>
) {
    const { supplyPoint } = meterPointEligibility
    const { meterPoint } = supplyPoint
    const { address } = meterPoint

    return {
        billingAddress: address,
        electricity: {
            marketName: supplyPoint.marketName,
            supplyPoint: {
                id: supplyPoint.id,
                isEligible: meterPointEligibility.isEligible,
                meterPoint: {
                    id: meterPoint.id,
                    address,
                    serviceLevel: meterPoint.serviceLevel,
                    isCommunicating: isPrmCommunicating(meterPoint.serviceLevel),
                    isLinky: meterPoint.meterKind === ElectricityMeterKind.Linky,
                    offPeakLabel: meterPoint.offPeakLabel,
                    offPeakValues: meterPoint.offPeakValues,
                    providerCalendarId: meterPoint.providerCalendar?.id || null,
                    providerCalendarName: meterPoint.providerCalendar?.name || null,
                    subscribedMaxPower: meterPoint.subscribedMaxPower,
                    poweredStatus: meterPoint.poweredStatus,
                    circuitBreakerIntensity: meterPoint.circuitBreakerIntensity,
                    isSensitive: meterPoint.isSensitive,
                    meterKind: meterPoint.meterKind,
                },
            },
            providerCalendarId: meterPoint.providerCalendar?.id || null,
            readings: null,
        },
    }
}
